<template>
    <div class="input-container">
        <div class="input-header">{{ title }}<span class="red-star">*</span></div>
        <label for="datepicker" class="datepicker-ui">
            <img
                class="datepicker-icon"
                src="@/assets/campaignlist/carbon_calendar.svg"
                alt=""
            />
            <div class="datepicker-value">{{ content }}</div>
            <img class="white-arrow" src="@/assets/home/white_dropdown.svg" />
        </label>
        <input
            id="datepicker"
            :min="minDate"
            type="date"
            v-model="content"
        />
    </div>
</template>

<script>
import Moment from "moment";

export default {
    name: "DatePicker",
    props: {
        title: String,
        value: String
    },
    computed: {
        content: {
            get() {
                return this.value || 'กรุณาเลือกวันที่';
            },
            set(val) {
                let dateFormat = Moment(val).format("DD / MMM / YY");
                this.$emit("input", dateFormat);
                let dateObject = {'name': 'date', 'value': val}
                this.$emit("setStartDate", dateObject);
            }
        }
    },
    data() {
        return {
            minDate: ""
        };
    },
    created() {
        this.setMinDate();
    },
    methods: {
        setMinDate() {
            this.minDate = Moment()
                .add(1, "days")
                .format("YYYY-MM-DD");
        },
    }
};
</script>

<style lang="scss" scoped>
.red-star {
    color: #e1261c;
}
.input-container {
    position: relative;
    .input-header {
        font-size: 14px;
        color: #908276;
    }
    label {
        margin: 0;
    }
    .datepicker-ui {
        display: flex;
        padding: 10px;
        .datepicker-icon {
            margin-right: 15px;
        }
        .datepicker-value {
            min-width: 66vw;
            font-size: 16px;
        }
    }
}
input[type="date"]::-webkit-datetime-edit {
    background: transparent;
    color: transparent;
    height: 0px;
}
input[type="date"] {
    border: none;
    background: transparent;
    height: 0px;
    margin-left: 50px;
}
input[type="date"]::-webkit-calendar-picker-indicator {
    background: transparent;
    color: transparent;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    height: auto;
    width: auto;
}
</style>
